import api from "../api";

export function getPrescriptionsByCartId (cartId) {
    return api.get(`/cart/${cartId}/prescriptions`);
}

export function sendPrescriptionsFilesToCart (files, cartId) {
    const formData = new FormData();
    files.forEach(file => {
        formData.append('prescriptions', file);
    })
    return api.post(`/cart/${cartId}/prescriptions`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}